<template>
  <div id="table">
    <table class="table" cellpadding="0" cellspacing="0">
      <tr>
        <td class="text-center">วันที่</td>
        <td>
          <flat-pickr :config="{time_24hr: true, dateFormat: 'Y-m-d'}" v-model="lotto.lotto_date" placeholder="เลือกวันที่" :disabled="true" />
        </td>
      </tr>
      <tr>
        <td class="text-center">รอบที่</td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal" name="round" v-validate="'numeric'" data-vv-as="*" data-vv-validate-on="blur" placeholder="รอบที่" maxlength="2" v-model="lotto.round" :disabled="true">
          <div class="text-danger text-sm">{{ errors.first('round') }}</div>
        </td>
      </tr>
      <tr>
        <td class="text-center">เวลาปิดรับ</td>
        <td>
          <flat-pickr :config="{enableTime: true, enableSeconds: true, time_24hr: true, dateFormat: 'Y-m-d H:i:S'}" v-model="lotto.close_date" placeholder="เวลาเริ่มหมุน" :disabled="true" />
        </td>
      </tr>
      <tr>
        <td class="text-center">เวลาเริ่มหมุน</td>
        <td>
          <flat-pickr :config="{enableTime: true, enableSeconds: true, time_24hr: true, dateFormat: 'Y-m-d H:i:S'}" v-model="lotto.start_spin" placeholder="เวลาเริ่มหมุน" :disabled="true" />
          <div v-if="invalidStartSpin" class="text-danger text-sm">กรุณาใส่เวลาเริ่มหมุน</div>
        </td>
      </tr>
      <tr>
        <td class="text-center">เวลาแสดงผล</td>
        <td>
          <flat-pickr :config="{enableTime: true, enableSeconds: true, time_24hr: true, dateFormat: 'Y-m-d H:i:S'}" v-model="lotto.show_result" placeholder="เวลาแสดงผล" :disabled="true" />
        </td>
      </tr>
      <tr>
        <td class="text-center">ผล 5 ตัว</td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal" name="number" v-validate="'length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="ตัวเลข 5 ตัว" maxlength="5" v-model="lotto.result.number">
          <div class="text-danger text-sm">{{ errors.first('number') }}</div>
        </td>
      </tr>
      <tr>
        <td class="text-center">3 ตัว</td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal" name="threeTop" v-validate="'numeric|length:3'" data-vv-as="*" data-vv-validate-on="blur" placeholder="ตัวเลข 3 ตัว" maxlength="3" v-model="lotto.result.threeTop" disabled>
          <div class="text-danger text-sm">{{ errors.first('threeTop') }}</div>
        </td>
      </tr>
      <tr>
        <td class="text-center">2 ตัวบน</td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal" name="twoTop" v-validate="'numeric|length:2'" data-vv-as="*" data-vv-validate-on="blur" placeholder="ตัวเลข 2 ตัว" maxlength="2" v-model="lotto.result.twoTop" disabled>
          <div class="text-danger text-sm">{{ errors.first('twoTop') }}</div>
        </td>
      </tr>
      <tr>
        <td class="text-center">2 ตัวล่าง</td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal" name="twoBot" v-validate="'numeric|length:2'" data-vv-as="*" data-vv-validate-on="blur" placeholder="ตัวเลข 2 ตัว" maxlength="2" v-model="lotto.result.twoBot" disabled>
          <div class="text-danger text-sm">{{ errors.first('twoBot') }}</div>
        </td>
      </tr>
      <!-- <tr>
        <td class="text-center">Effect</td>
        <td>
          <vs-checkbox v-model="lotto.effect" color="success" vs-value="yes" />
        </td>
      </tr> -->
      <tr>
        <td colspan="2" class="text-center">
          <vs-button class="vs-xs-12 w-full" color="success" @click="save">บันทึก</vs-button>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
//import vSelect from 'vue-select'
//import moment from "moment"

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  name: 'ResultForm',
  components: {
    flatPickr,
    //vSelect
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      lotto: this.data,
      invalidStartSpin: false
    }
  },
  computed: {

  },
  methods: {
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.$emit('save', this.lotto)
        }
      })
    }
  }
}

</script>
<style lang="scss">
#table {
  .table {
    width: auto;
    background-color: #FFF;
    border-collapse: collapse;
  }

  .table {
    tr {
      td {
        &:first-child {
          width: 200px;
          font-weight: bold;
        }

        .vs-input--input {
          width: auto;
        }

        input {
          border: 1px solid rgba(0, 0, 0, 0.2);
          color: blue;
        }

        .vdp-datepicker input {
          width: auto;
        }
      }

      td {
        padding: 16px 8px;
        border: 1px solid #DDDDDD;
        border-collapse: collapse;
      }

      .no-boder-r {
        border-right: 0;
      }

      .no-boder-l {
        border-left: 0;
      }

      .no-boder-t {
        border-top: 0;
      }

      .no-boder-b {
        border-bottom: 0;
      }
    }
  }

  .text-center {
    text-align: center;
  }
}

</style>
